import { type EnhancedResDocumentOCRResultQuery } from '@/lib/queries/business/v1/ocr/result/types'

import { SELECT_ITEM_USE_SCANNED_NAME } from './review/ui/current-document-forms/existing-applicant-name-input/constants'

export const constructOCRDataPayload = (ocrResult: EnhancedResDocumentOCRResultQuery) => {
  const {
    taskId,
    caseNumber,
    applicantNameCandidate,
    applicantCandidateList,
    applicationFiledDate,
    caseType,
    caseAdditionalData,
    nationality,
    priorityDate,
    validFrom,
    validTo,
    rfeDueDate,
    interviewDate,
    biometricDate,
    serviceCenter,
  } = ocrResult

  const hasMatchingApplicant = applicantCandidateList.length > 0
  const usesScannedApplicantName =
    !applicantNameCandidate.matchingApplicantId ||
    applicantNameCandidate.matchingApplicantId === SELECT_ITEM_USE_SCANNED_NAME.value
  const matchingApplicantInfo = applicantCandidateList?.find(
    ({ applicantId }) => `${applicantId}` === applicantNameCandidate.matchingApplicantId
  )

  const applicantId = matchingApplicantInfo?.applicantId || 0 // NOTE: 0 means there is no applicant id
  const pathId = matchingApplicantInfo?.pathId || 0 // NOTE: 0 means there is no path id
  const finalApplicantName = !hasMatchingApplicant
    ? applicantNameCandidate.ocrScannedApplicantNameWhenNew
    : usesScannedApplicantName
      ? applicantNameCandidate.ocrScannedApplicantNameWhenExisting
      : matchingApplicantInfo?.applicantName

  return {
    taskId,
    caseNumber: caseNumber.value || '',
    applicant: {
      applicantId,
      applicantEmail: caseAdditionalData.email || '',
      applicantName: finalApplicantName || '',
      applicantPhone: caseAdditionalData.phone || '',
      pathId,
    },
    applicationFiledDate: {
      isNew: applicationFiledDate.isNew,
      text: applicationFiledDate.text || '',
      value: applicationFiledDate.value || '',
    },
    caseType: {
      isNew: caseType.isNew,
      text: caseType.text || '',
      value: caseType.value || '',
    },
    serviceCenter: {
      isNew: serviceCenter.isNew,
      text: serviceCenter.text || '',
      value: serviceCenter.value || '',
    },
    nationality: {
      isNew: nationality.isNew,
      text: nationality.text || '',
      value: nationality.value || '',
    },
    priorityDate: {
      isNew: priorityDate.isNew,
      text: priorityDate.text || '',
      value: priorityDate.value || '',
    },
    validFrom: {
      isNew: validFrom.isNew,
      text: validFrom.text || '',
      value: validFrom.value || '',
    },
    validTo: {
      isNew: validTo.isNew,
      text: validTo.text || '',
      value: validTo.value || '',
    },
    rfeDueDate: {
      isNew: rfeDueDate.isNew,
      text: rfeDueDate.text || '',
      value: rfeDueDate.value || '',
    },
    interviewDate: {
      isNew: interviewDate.isNew,
      text: interviewDate.text || '',
      value: interviewDate.value || '',
    },
    biometricDate: {
      isNew: biometricDate.isNew,
      text: biometricDate.text || '',
      value: biometricDate.value || '',
    },
    caseAdditionalData: {
      caseCategory: caseAdditionalData?.caseCategory || '',
      caseId: caseAdditionalData?.caseId || 0, // NOTE: 0 means there is no case id
      caseTags: caseAdditionalData?.caseTags?.map((tag) => tag?.trim()) || [],
    },
  }
}
